import React from 'react';
import SessionLayout from '../layouts/Session/Session';
import ForgotEmail from '../components/Session/ForgotEmail';
import {setPageTitle} from '../utils/helpers';

const ForgotEmailPageContainer = () => {
  setPageTitle('Forgot Email | Access your UK savings accounts');

  return (
    <SessionLayout>
      <ForgotEmail />
    </SessionLayout>
  );

};

export default ForgotEmailPageContainer;
